import { createSelector } from 'reselect';

export const getById = ({ productPhraseTR }) => productPhraseTR.byId;
export const getIds = ({ productPhraseTR }) => productPhraseTR.list.allIds;
export const getProductPhrase = (state, id) => getById(state)[id];

export const getProductPhraseTRList = createSelector([getIds, getById], (allIds, byId) => allIds.map(id => byId[id]));
